import React from "react";
import {Line} from "react-chartjs-2";
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend);


type Props = {
    data: { day: string; value: number }[];
    total: string;
};

const MonthlyValuesLineChart: React.FC<Props> = ({data, total}) => {
    const getCurrentMonthName = () => {
        let months = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];

        let currentDate = new Date();
        let currentMonthIndex = currentDate.getMonth();
        let currentYear = currentDate.getFullYear();

        return months[currentMonthIndex] + " de " + currentYear;
    };


    const chartData = {
        labels: data.map((item) => item.day),
        datasets: [
            {
                label: "Total Recebido: " + total,
                data: data.map((item) => item.value),
                borderColor: "#ff7526",
                backgroundColor: "#ff7526",
                pointBackgroundColor: "#ff7526",
                pointBorderColor: "#fff",
                borderWidth: 2,
                tension: 0.3,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const,
            },
            title: {
                display: true,
                text: "Valores Recebidos no Mês de " + getCurrentMonthName(),
            },
            tooltip: {
                callbacks: {
                    label: (context: any) => {
                        let value = context.raw || 0;
                        return `R$ ${value.toFixed(2).replace('.', ',')}`;
                    },
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true, // O eixo Y começa em zero
                ticks: {
                    callback: (value: number | string) => {
                        return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
                    },
                },
            },
        },
    };

    return <Line data={chartData} options={options}/>;
};

export default MonthlyValuesLineChart;
